import type { RouteRecordRaw } from 'vue-router'

/**
 * Rutas públicas del portal de PLATAFORMA (dominio raíz).
 * platformOnly: en el host de un bufete se bloquean.
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/registro',
    name: 'plataforma.registro',
    component: () => import('./views/Onboarding.vue'),
    meta: { layout: 'site', platformOnly: true, breadcrumb: 'Crear bufete' },
  },
]

export default routes
